import React, { useState } from 'react';
import { cryptoPairLabel } from '../composables/fetchCrypto';
import { toast } from 'react-hot-toast';

interface CopySignalToolProps {
  symbol: string;
}

const CopySignalTool: React.FC<CopySignalToolProps> = ({ symbol }) => {
  const [useDecimal, setUseDecimal] = useState(true);

  const handleCopySignal = () => {
    const savedData = localStorage.getItem(`chartLines_${symbol}`);
    if (!savedData) {
      toast.error(`ไม่พบข้อมูลเส้นของ ${cryptoPairLabel(symbol)}`);
      return;
    }

    try {
      const { lines } = JSON.parse(savedData);
      if (!lines || lines.length === 0) {
        toast.error("ยังไม่มีการตีเส้นแนวรับ-แนวต้าน");
        return;
      }

      const supports = lines
        .filter((l: any) => l.type === 'support')
        .sort((a: any, b: any) => b.price - a.price);

      const resistances = lines
        .filter((l: any) => l.type === 'resistance')
        .sort((a: any, b: any) => a.price - b.price);

      const formatPrice = (p: number) => 
        useDecimal ? p.toFixed(1) : Math.round(p).toString();

      const supportText = supports.length > 0 
        ? supports.map((l: any) => `$${formatPrice(l.price)}`).join(', ') 
        : '-';

      const resistanceText = resistances.length > 0 
        ? resistances.map((l: any) => `$${formatPrice(l.price)}`).join(', ') 
        : '-';

      const textToCopy = `${cryptoPairLabel(symbol)}\nแนวรับ : ${supportText}\nแนวต้าน : ${resistanceText}`;

      navigator.clipboard.writeText(textToCopy).then(() => {
        toast.success(`คัดลอกแผนเทรด ${cryptoPairLabel(symbol)} แล้ว!`);
      });

    } catch (err) {
      toast.error("เกิดข้อผิดพลาดในการคัดลอก");
    }
  };

  return (
    // ปรับ Container ให้ดูเบาบางลง
    <div className="flex items-center gap-3  bg-[#1c1c1e]/40 backdrop-blur-sm border border-gray-800 rounded-xl mt-2 mb-2 shadow-inner">
      
      {/* ปุ่มกด: ปรับให้เล็กลง, ใช้ Gradient โปร่งแสง, และเพิ่ม Glow เส้นขอบ */}
    <button
        onClick={handleCopySignal}
        title="คัดลอกแผนเทรด"
        className="flex items-center justify-center gap-1.5 py-1 px-2 md:px-2 bg-gradient-to-r from-blue-600/20 to-indigo-600/20 hover:from-blue-600/40 hover:to-indigo-600/40 text-blue-300 rounded-lg text-xs font-bold transition-all active:scale-95 border border-blue-500/30 hover:border-blue-400 shadow-[0_0_15px_rgba(37,99,235,0.1)]"
      >
        <span className="text-sm md:text-base">📄</span> 
        <span className="hidden md:inline">คัดลอก</span>
      </button>

      {/* ส่วน Checkbox: ปรับให้กระทัดรัดและวางข้างปุ่ม */}
     <label className="flex items-center gap-1 cursor-pointer group flex-shrink-0 pr-1">
        <input 
          type="checkbox" 
          checked={useDecimal}
          onChange={(e) => setUseDecimal(e.target.checked)}
          className="w-3 h-3 md:w-3.5 md:h-3.5 accent-blue-500 rounded border-gray-700 bg-gray-900 cursor-pointer"
        />
        <span className="hidden md:inline text-[10px] md:text-[11px] text-gray-400 group-hover:text-blue-400 transition-colors font-medium">
          ทศนิยม
        </span>
      </label>
    </div>
  );
};

export default CopySignalTool;